import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { getAccessToken } from "../utils/authUtils";

export const useAccessToken = () => {
  const { instance } = useMsal();
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getAccessToken(instance);
        setAccessToken(token);
      } catch (err) {
        console.error("Failed to acquire access token:", err);
      }
    };
    fetchToken();
  }, [instance]);

  return accessToken;
};